// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusRefreshIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M13.8333 7.16667C13.8333 10.8467 10.8467 13.8333 7.16667 13.8333C3.48667 13.8333 1.24 10.1267 1.24 10.1267M1.24 10.1267H4.25333M1.24 10.1267V13.46M0.5 7.16667C0.5 3.48667 3.46 0.5 7.16667 0.5C11.6133 0.5 13.8333 4.20667 13.8333 4.20667M13.8333 4.20667V0.873333M13.8333 4.20667H10.8733"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { StatusRefreshIcon };
